import { useAuth } from '../context/AuthContext';
import { useUserData } from './useUserData';
import { SUBSCRIPTION_FEATURES, type SubscriptionFeatures } from '../types/subscription';

export function useSubscription() {
  const { user } = useAuth();
  const { userData } = useUserData(user?.uid || '');
  
  const features: SubscriptionFeatures = userData?.subscriptionTier ? 
    SUBSCRIPTION_FEATURES[userData.subscriptionTier] : 
    SUBSCRIPTION_FEATURES.free;

  return {
    tier: userData?.subscriptionTier || 'free',
    features,
    isPremium: userData?.subscriptionTier === 'premium'
  };
}